<script>
    import JoinbtnBlack from '../mobilebtn.svelte';
    import {initializeGsapAnimation} from '../../utils';
    import {onMount} from 'svelte';
    let para3;
    let img1;
    let img2;
    let main;
    onMount(onStart);
    /**
     */
    function onStart() {
        initializeGsapAnimation( main, main, [{backgroundColor: '#f4eeec', duration: 1},
            {backgroundColor: 'black', duration: 1}], 3);
        initializeGsapAnimation( main, para3, [{top: 'max(89.252vw, 41.32vh)', duration: 1},
            {top: 'max(77.252vw, 35.764vh)', duration: 1}], 3);
        initializeGsapAnimation( main, img1, [{top: 'max(95.561vw,44.241vh)', duration: 1},
            {top: 'max(77.252vw, 35.764vh)', duration: 1}], 3);
        initializeGsapAnimation( main, img2, [{top: 'max(123.131vw, 57.00vh)', duration: 1},
            {top: 'max(100vw, 46.29vh)', duration: 1}], 3);
}
</script>


<div class="bg" style="" bind:this={main}>
    <img id="img2" src="images/performersMobile/img2.svg" alt="" />
    <div class="performers2">
        <div class="bg2" bind:this={img1}>
            <img id="bg2" src="images/performersMobile/bg2.svg" alt="" />
        </div>
        <div class="bg25" bind:this={img2}>
            <img id="bg25" src="images/performersMobile/bg25.svg" alt="" />
            <div class="btn"><JoinbtnBlack  state='Performer'/></div>
    
        </div>
        <div class="sub">Performers & Opus</div>
        <div class="h1">MOTION RECORDING ARTISTS</div>
        <div class="para1">
            You don't have to be an actor to record motions. The symphony is in
            the variety of motions from everyone.
        </div>
        <div class="para2">
            Our <span style="color:#1C7BFF;font-weight:600;"><u>motion recording app</u></span> turns a simple smartphone into a production
            capture studio.
        </div>
        <div class="para3" bind:this={para3}>
            Be the part of early adopters, vote on what features you would like
            to see first or simply join the discussion on the future of
            democratized entertainment.
        </div>
    </div>
</div>

<style>
   
    .btn {
        position: absolute;
        top: max(65vw, 30.09vh);
        left: -21vw;
    }
    .bg {
        position: relative;
        overflow: hidden;
        height: max(216.355vw, 100.16vh);
        font-family: "Orbitron";
        background: #f4eeec;
    }
    .performers2 {
        height: max(216.355vw, 100.16vh);
    }
    #img2,
    #bg2 {
        position: absolute;
    }
    #img2 {
       
        height: 69.093vw;
        width: 40.103vw;
        top: max(11.916vw, 5.516vh);
        right: 0;
    }
    .bg2,
    .bg25 {
        position: absolute;
        height: 120.607vw;
        width: 90vw;
        left: 0vw;
        top: max(95.561vw, 44.241vh);
    }
    .bg25 {
        left: 28.579vw;
        top: max(123.131vw, 57.00vh);
        width: 75vw;
        height: 89vw;
    }
    #bg2,
    #bg25 {
        height: 100%;
        width: 100%;
    }
    .sub {
        position: absolute;
        left: 6.308vw;
        top: max(39.019vw, 18.06vh);
        font-size: 2.336vw;
        font-weight: 400;
        line-height: 2.336vw;
        text-align: left;
    }
    .h1 {
        position: absolute;
        font-size: 7.009vw;
        font-weight: 900;
        line-height: 7.009vw;
        letter-spacing: 0.06em;
        text-align: left;
        left: 6.308vw;
        top: max(42.991vw, 19.903vh);
    }
    .para1,
    .para2,
    .para3 {
        font-family: "Orbitron";
        position: absolute;
        font-size: 2.804vw;
        font-weight: 400;
        line-height: 3.972vw;
        letter-spacing: 0.06em;
        text-align: left;
    }
    .para3 {
        height: 33.645vw;
        width: 36.682vw;
        left: 56.776vw;
        top: max(89.252vw, 41.32vh);
        text-align: center;
    }
    .para1 {
        top: max(60.047vw, 27.79vh);
        height: 11.215vw;
        width: 84.813vw;
        left: 7.009vw;
    }
    .para2 {
        height: 7.477vw;
        width: 80.374vw;
        left: 7.009vw;
        top: max(75.234vw, 34.83vh);
    }
</style>
